import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { linkPage } from "@utils/router";

import { useQuery } from "@tanstack/react-query";
import { SchoolService } from "@services/school.service";
import { HomeService } from "@services/home.service";
import { Spiner } from "@components/loaders/spiner";
import { toRp } from "@utils/helper";
import { Mading } from "@services/dtos/home.dto";
import { useThemeStore } from "@stores/theme.store";
import { androidIsAvailableBiometric } from "@utils/android";
import moment from "moment";

import LogoHomePage from "@assets/images/logo-tarbiyatus.png";
import {
  LuAlertTriangle,
  LuArrowRightLeft,
  LuBookOpen,
  LuCalendarDays,
  LuChevronRight,
  LuClock,
  LuHeartPulse,
  LuHistory,
  LuLayoutGrid,
  LuReceipt,
  LuStethoscope,
  LuTrophy,
  LuUser,
} from "react-icons/lu";
import { PopupError } from "@components/general/popup";

export const DashboardPage = () => {
  const navigate = useNavigate();
  const { setAppBar } = useThemeStore((state) => state);

  const [popupError, setPopupError] = useState<boolean>(false);

  const kategori = "*";
  const { data: dataNis } = useQuery({
    queryKey: [SchoolService.queries.GET_SCHOOL_STUDENT_BIO],
    queryFn: SchoolService.studentBio,
  });
  const nis = dataNis?.data?.nis ?? "";
  // const gender = dataNis?.data?.gender ?? "";

  const { data: dataUangSaku, isPending: isPendingUangSaku } = useQuery({
    queryKey: [HomeService.queries.GET_BILLS_AND_BALANCES, nis],
    queryFn: () => HomeService.billsAndBalances({ nis }),
  });

  // const { data, isPending } = useQuery({
  //   queryKey: [SchoolService.queries.GET_SCHOOL_STUDENT_BIOGRAPHY, nis],
  //   queryFn: () => SchoolService.studentBiography(nis),
  // });

  const { data: dataMading, isPending: isPendingMading } = useQuery({
    queryKey: [HomeService.queries.GET_MADING, kategori, "5"],
    queryFn: () => HomeService.mading(kategori, "5"),
  });

  useEffect(() => {
    // const setupUnreadInbox = setTimeout(() => androidUnreadInbox(), 1000);
    const setupBiometric = setTimeout(() => {
      localStorage.setItem("is-biometric", "false");
      androidIsAvailableBiometric();
    }, 1000);

    return () => {
      clearTimeout(setupBiometric);
      // clearTimeout(setupUnreadInbox);
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    setAppBar({ title: "Beranda", show: true, leading: "home" });
  }, [setAppBar]);

  const openDetailMading = (detailMading: Mading) => {
    navigate(linkPage.MADING_DETAIL, { state: detailMading });
  };

  return (
    <>
      {/* Header: logo kiri, tanggal kanan */}
      <div className="profile-header">
        <div className="tw-pt-[20px] tw-pb-[10px] tw-px-4 tw-flex tw-items-center tw-justify-between">
          <img src={LogoHomePage} alt="" className="tw-h-[55px]" />
          <div className="tw-text-right">
            <div className="tw-text-white/60 tw-text-[10px]">Hari ini</div>
            <div className="tw-text-white tw-text-xs tw-font-medium">
              {moment().format("dddd, DD MMM YYYY")}
            </div>
          </div>
        </div>

        {/* Balance terpusat di header */}
        <div className="tw-px-4 tw-pt-2 tw-pb-6 tw-text-center">
          <div className="tw-text-white/70 tw-text-xs tw-mb-1 tw-tracking-wide">
            Uang Saku Tersisa
          </div>
          <div className="tw-text-3xl tw-font-bold tw-text-white tw-mb-5">
            {isPendingUangSaku ? (
              <Spiner />
            ) : (
              toRp(dataUangSaku?.data?.saldo ?? 0)
            )}
          </div>

          {/* Quick action pills */}
          <div className="tw-flex tw-justify-center tw-gap-3">
            <div
              onClick={() =>
                navigate(
                  linkPage.FINANCE_REQUEST_VA.replace(":type", "topup"),
                  {
                    state: { tagihan: false, tipe: "topup" },
                  },
                )
              }
              className="tw-flex tw-items-center tw-gap-2 tw-px-5 tw-py-2 tw-rounded-full tw-cursor-pointer"
              style={{ background: "rgba(255,255,255,0.2)" }}
            >
              <LuArrowRightLeft className="tw-text-white tw-text-lg" />
              <span className="tw-text-white tw-text-xs tw-font-medium">
                Top-up
              </span>
            </div>
            <div
              onClick={() => navigate(linkPage.FINANCE_POCKET)}
              className="tw-flex tw-items-center tw-gap-2 tw-px-5 tw-py-2 tw-rounded-full tw-cursor-pointer"
              style={{ background: "rgba(255,255,255,0.2)" }}
            >
              <LuHistory className="tw-text-white tw-text-lg" />
              <span className="tw-text-white tw-text-xs tw-font-medium">
                Riwayat
              </span>
            </div>
          </div>
        </div>
      </div>
      {/* end of Header & Pocket */}

      {/* Tagihan */}
      <div className="tw-px-4 tw-mb-4">
        <div
          className="card-body tw-flex tw-items-center tw-gap-3"
          style={{ borderLeft: "4px solid #ef4444" }}
          onClick={() => navigate(linkPage.MENU_FINANCE)}
        >
          <LuClock className="tw-text-3xl tw-shrink-0 tw-text-red-400" />
          <div className="tw-flex-1">
            <div className="tw-text-xs tw-text-text-secondary">
              Total Tagihan Hari Ini
            </div>
            <div className="tw-text-base tw-font-bold tw-text-red-500">
              {isPendingUangSaku ? (
                <Spiner />
              ) : (
                toRp(dataUangSaku?.data?.tagihan ?? 0)
              )}
            </div>
          </div>
          <LuChevronRight className="tw-text-text-tertiary tw-text-lg" />
        </div>
      </div>
      {/* end of Tagihan */}

      {/* Menu */}
      <div className="tw-mb-4 tw-px-4">
        <div className="tw-px-2 tw-pb-0 card-body card-body-grid">
          <div className="tw-mx-2 tw-pb-2 card-grid">
            <div
              onClick={() => navigate(linkPage.MENU_FINANCE)}
              className="tw-m-0"
            >
              <div className="tw-flex tw-items-center tw-justify-center tw-mx-auto tw-mb-2 tw-rounded-2xl tw-w-[44px] tw-h-[44px] tw-bg-[#ecf4ff]">
                <LuReceipt className="tw-text-2xl tw-text-[#4D8EFF]" />
              </div>
              <div className="tw-line-clamp-1 card-name">Tagihan</div>
            </div>
          </div>

          <div className="tw-mx-2 tw-pb-2 card-grid">
            <div
              onClick={() => navigate(linkPage.PERMIT_DATA_PAGE)}
              className="tw-m-0"
            >
              <div className="tw-flex tw-items-center tw-justify-center tw-mx-auto tw-mb-2 tw-rounded-2xl tw-w-[44px] tw-h-[44px] tw-bg-[#ffecec]">
                <LuCalendarDays className="tw-text-2xl tw-text-[#ff6b6b]" />
              </div>
              <div className="tw-line-clamp-1 card-name">Laporan Izin</div>
            </div>
          </div>

          <div className="card-grid">
            <div
              onClick={() => navigate(linkPage.INFO_BIOGRAPH)}
              className="tw-m-0"
            >
              <div className="tw-flex tw-items-center tw-justify-center tw-mx-auto tw-mb-2 tw-rounded-2xl tw-w-[44px] tw-h-[44px] tw-bg-[#f0fdf4]">
                <LuUser className="tw-text-2xl tw-text-[#22c55e]" />
              </div>
              <div className="tw-line-clamp-1 card-name">Biodata</div>
            </div>
          </div>

          <div className="tw-mx-2 tw-pb-2 card-grid">
            <div onClick={() => navigate(linkPage.HEALTH_PAGE)}>
              <div className="tw-flex tw-items-center tw-justify-center tw-mx-auto tw-mb-2 tw-rounded-2xl tw-w-[44px] tw-h-[44px] tw-bg-[#e0f9f2]">
                <LuStethoscope className="tw-text-2xl tw-text-[#10b981]" />
              </div>
              <div className="tw-line-clamp-1 card-name">Info UKP</div>
            </div>
          </div>

          <div className="card-grid">
            <div onClick={() => navigate("/school/tafaquh")} className="tw-m-0">
              <div className="tw-flex tw-items-center tw-justify-center tw-mx-auto tw-mb-2 tw-rounded-2xl tw-w-[44px] tw-h-[44px] tw-bg-[#e4e8ff]">
                <LuBookOpen className="tw-text-2xl tw-text-[#6366f1]" />
              </div>
              <div className="tw-line-clamp-1 card-name">Tafaquh</div>
            </div>
          </div>

          <div className="tw-mx-2 tw-pb-2 card-grid">
            <div
              onClick={() => navigate(linkPage.VIOLATION_PAGE)}
              className="tw-m-0"
            >
              <div className="tw-flex tw-items-center tw-justify-center tw-mx-auto tw-mb-2 tw-rounded-2xl tw-w-[44px] tw-h-[44px] tw-bg-[#ffecec]">
                <LuAlertTriangle className="tw-text-2xl tw-text-[#ef4444]" />
              </div>
              <div className="tw-line-clamp-1 card-name">Pelanggaran</div>
            </div>
          </div>

          <div className="tw-mx-2 tw-pb-2 card-grid">
            <div
              onClick={() => navigate(linkPage.ACHIEVEMENT_PAGE)}
              className="tw-m-0"
            >
              <div className="tw-flex tw-items-center tw-justify-center tw-mx-auto tw-mb-2 tw-rounded-2xl tw-w-[44px] tw-h-[44px] tw-bg-[#fef3c7]">
                <LuTrophy className="tw-text-2xl tw-text-[#f59e0b]" />
              </div>
              <div className="tw-line-clamp-1 card-name">Prestasi</div>
            </div>
          </div>

          <div className="card-grid">
            <div
              onClick={() => navigate("/menu/other-menu")}
              className="tw-m-0"
            >
              <div className="tw-flex tw-items-center tw-justify-center tw-mx-auto tw-mb-2 tw-rounded-2xl tw-w-[44px] tw-h-[44px] tw-bg-[#f3f4f6]">
                <LuLayoutGrid className="tw-text-2xl tw-text-[#6b7280]" />
              </div>
              <div className="tw-line-clamp-1 card-name">Lainnya</div>
            </div>
          </div>
        </div>
      </div>
      {/* end of Menu */}

      {/* Mading */}
      {isPendingMading ? (
        <div className="tw-mt-5 tw-py-3 tw-m-auto tw-text-center">
          <Spiner />
        </div>
      ) : (dataMading?.data ?? []).length === 0 ? (
        <></>
      ) : (
        <div className="tw-pb-20 tw-mt-2 tw-px-4">
          <div className="tw-pt-2 tw-pb-3 tw-flex tw-justify-between tw-items-center">
            <div className="tw-text-base tw-font-semibold tw-text-text-primary">
              Informasi Terkini
            </div>
            <div
              onClick={() => navigate("/mading/list")}
              className="tw-text-xs tw-text-accent-primary tw-cursor-pointer"
            >
              Lihat Semua
            </div>
          </div>
          <div className="tw-flex tw-flex-col tw-gap-3">
            {(dataMading?.data ?? [])
              .sort((a, b) => moment(b.tanggal).diff(moment(a.tanggal)))
              .slice(0, 3)
              .map((mading, idx) => (
                <div
                  key={idx}
                  onClick={() => openDetailMading(mading)}
                  className="tw-flex tw-gap-3 tw-items-center card-body tw-cursor-pointer tw-p-3"
                >
                  <div
                    className="tw-rounded-xl tw-shrink-0 tw-w-[72px] tw-h-[72px] tw-bg-background-300"
                    style={{
                      backgroundImage: `url(${mading.gambar})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                    }}
                  />
                  <div className="tw-flex-1 tw-overflow-hidden">
                    <div className="tw-text-[10px] tw-text-text-tertiary tw-mb-1">
                      {moment(mading.tanggal ?? Date.now()).format(
                        "dddd, DD MMMM YYYY",
                      )}
                    </div>
                    <div
                      className="tw-text-sm tw-font-medium tw-text-text-primary"
                      style={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {mading.judul}
                    </div>
                  </div>
                  <LuChevronRight className="tw-text-text-tertiary tw-shrink-0" />
                </div>
              ))}
          </div>
        </div>
      )}
      {/* end of Mading */}

      <PopupError
        open={popupError}
        title="Fitur Tidak Tersedia"
        message="Fitur ini sedang dalam perbaikan. Kami akan segera mengaktifkannya kembali."
        textConfirm="Tutup"
        onConfirm={() => setPopupError(false)}
      />
    </>
  );
};
